module.exports = __webpack_public_path__ + "img/ECUNION-Logo.06d091c2.png";